// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmUpdateModal_modal__hP6dq","card":"ConfirmUpdateModal_card__xyzqI"};